import IconButtonComponent from '../../Basic/IconButton/IconButton.mjs';
import styled from 'styled-components';

const SearchButton = styled(IconButtonComponent) `
  margin-right: 1.25rem;
  border-radius: 0 8px 8px 0;
  border-left: none;

  svg {
    margin-right: 2px;
    margin-top: 1px;
  }
`;
const StyledForm = styled.form `
  position: relative;
  max-height: 40px;
  display: flex;
  justify-content: space-between;
  width: 100%;
  border: 1px solid ${props => props.theme.colors.darkGray};
  border-radius: 8px;
  background-color: ${props => props.theme.colors.backgroundColor};
  transition: all ${props => props.theme.animation.duration.quick2}
    ${props => props.theme.animation.easing.productive.standard};
  box-shadow: 0 0 0 0 ${props => props.theme.colors.darkGray}20;

  @media (pointer: fine) {
    &:hover {
      border-color: ${props => props.theme.colors.darkGrayShade};
      box-shadow: 0 0 8px ${props => props.theme.colors.darkGray}30;
    }
  }

  &:focus-within {
    border-color: ${props => props.theme.colors.mist};
    box-shadow: 0 0 0 2px ${props => props.theme.colors.mist}40,
      0 0 12px ${props => props.theme.colors.mist}50, 0 0 20px ${props => props.theme.colors.mist}30;
  }
`;
const StyledSearchField = styled.input `
  border: none;
  border-right: none;
  background: transparent;
  background-color: transparent;
  color: ${props => props.theme.colors.textColor};
  font-size: ${props => props.theme.typography.text.tiny.fontSize};
  font-weight: ${props => props.theme.typography.fontWeight.regular};
  line-height: ${props => props.theme.typography.text.tiny.lineHeight};
  padding: 1rem 3.5rem 1rem 1rem;
  width: 100%;
  box-sizing: border-box;
  border-radius: 8px 0 0 8px;

  &::placeholder {
    color: ${props => props.theme.colors.mutedTextColor};
  }

  &:focus {
    outline: none;
    background-color: transparent;
    border: none;
    border-right: none;

    &::placeholder {
      color: transparent;
    }
  }

  /* Prevent browser autofill from changing background color */
  &:-webkit-autofill,
  &:-webkit-autofill:hover,
  &:-webkit-autofill:focus,
  &:-webkit-autofill:active {
    -webkit-box-shadow: 0 0 0 30px ${props => props.theme.colors.backgroundColor} inset !important;
    -webkit-text-fill-color: ${props => props.theme.colors.textColor} !important;
    background-color: transparent !important;
    background: transparent !important;
    border-radius: 8px 0 0 8px;
    border: none !important;
    border-right: none !important;
  }

  /* Firefox autofill prevention */
  &:-moz-autofill {
    background-color: transparent !important;
    background: transparent !important;
    border-radius: 8px 0 0 8px;
    border: none !important;
    border-right: none !important;
  }

  @media screen and (max-width: ${props => props.theme.breakpoints.md}) {
    padding: 0.875rem 3rem 0.875rem 0.875rem;
  }
`;
const StyledCloseIcon = styled.button `
  position: absolute;
  right: -0.75rem;
  top: -0.5rem;
  background: ${props => props.theme.colors.backgroundColor};
  border: 1px solid ${props => props.theme.colors.darkGray};
  color: ${props => props.theme.colors.iconColor};
  cursor: pointer;
  padding: 0.25rem;
  border-radius: 50%;
  transition: all ${props => props.theme.animation.duration.quick1}
    ${props => props.theme.animation.easing.productive.standard};
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  z-index: 10;

  &:hover:not(:disabled) {
    border-color: ${props => props.theme.colors.darkGrayShade};
    box-shadow: 0 0 8px ${props => props.theme.colors.darkGray}30;
  }

  &:active:not(:disabled) {
    transform: scale(0.95);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  svg {
    width: 16px;
    height: 16px;
  }

  @media screen and (max-width: ${props => props.theme.breakpoints.md}) {
    width: 22px;
    height: 22px;
    right: -0.6rem;
    top: -0.4rem;

    svg {
      width: 14px;
      height: 14px;
    }
  }
`;

export { SearchButton, StyledCloseIcon, StyledForm, StyledSearchField };
//# sourceMappingURL=Search.styles.mjs.map
